<template>
    <div class="step step--8">
        <div class="step__container">

            <!-- Title -->
            <div class="step__title" ref="title">
                <p>Now to start your 7 day free trial</p>
            </div>

            <!-- Subtitle -->
            <div class="step__subtitle" ref="subtitle">
                <p>We’ll need a credit card to get started, but don’t worry. You can cancel anytime before the end of the trial.</p>
            </div>

            <!-- Apple Pay and Paypal Buttons -->
            <!-- <div class="step__services" ref="service">
                <div class="step__service">
                    <appleIcon></appleIcon>
                </div>
                <div class="step__service">
                    <paypalIcon></paypalIcon>
                </div>
            </div> -->

            <!-- Cards Graphic -->
            <div class="step__payment" ref="payment">
                <p class="step__payment-title">Payment Information</p>
                <cardsIcon></cardsIcon>
            </div>

            <!-- Credit Card Form -->
            <div class="step__form" ref="form">
                <div class="step__form-block">

                    <!-- Card Name -->
                    <InputField
                        title="NAME ON CARD"
                        type="name"
                        placeholder="Name"
                        autocomplete="name"
                        autocapitalize="words"
                        v-model="cardName"
                        :disabled="false"
                        :errored="false"
                        :validated="nameValid(cardName)"
                        errorMessage=""
                    ></InputField>

                    <!-- Card Name FOR COMPUTED -->
                    <div class="input" style="display: none">
                        <label class="input__label" for="name">NAME ON CARD</label>
                        <div class="input__block">

                            <input id="name" class="input__main" placeholder="Name">
                        </div>
                    </div>

                    <!-- Card Number -->
                    <div class="input">
                        <label class="input__label" for="card">CARD INFO</label>
                        <!-- <div class="input__block"> -->
                            <div class="input__stripecard" id="card-element"></div>
                            <div class="input__validate">
                                <p>{{ cardErrorMessage }}</p>
                            </div>
                        <!-- </div> -->
                    </div>

                </div>
            </div>

            <!-- Submit Pay Button -->
            <div class="step__button" ref="button">
                <a href="#" @click.prevent="goNextStep" class="button button--full" :class="{ 'button--disable': !this.isValid }">
                    <span class="button__title">Start free trial</span>
                    <span class="button__subtitle">
                        You’ll be charged $1.00/month on {{ weekFromNow() }}.
                    </span>
                </a>
            </div>

        </div>
    </div>
</template>

<style scoped>


</style>

<script>

    import InputField from "@/components/1-common/InputField";
    import checkIcon from '@/assets/svg/check.svg';
    import checkWhiteIcon from '@/assets/svg/check-white.svg';
    import plusIcon from '@/assets/svg/plus.svg';

    import appleIcon from '@/assets/svg/apple.svg';
    import paypalIcon from '@/assets/svg/paypal.svg';
    import cardsIcon from '@/assets/svg/cards.svg';

    import { TimelineMax } from 'gsap';

    // const stripe = Stripe('pk_test_Pry84GX42RNLAqFSbwNnSPfA');
    const stripe = Stripe('pk_live_Y59xHOav57V3xRx2PlO0lRHP');

    const elements = stripe.elements();
    var card; // Have to declare here so I can use in goNextStep()

    const axios =  require('axios');

    let tl = new TimelineMax({
        delay: 1
    });

    export default {
        name: 'Step5_CreditCard',
        data() {
            return {
                cardName: '',
                cardErrorMessage: '',
                cardComplete: false
            }
        },
        watch: {
            cardName: function (val) {
                
                const data = {
                    field: 'card_name',
                    new_value: val
                }
                amplitude.getInstance().logEvent('input_changed', data);
            },
            cardErrorMessage: function (val) {
                
                const data = {
                    error_message: val
                }
                amplitude.getInstance().logEvent('error_message_changed', data);
            },
            cardComplete: function (val) {
                
                const data = {
                    bool: val
                }
                amplitude.getInstance().logEvent('card_complete_bool', data);
            },
        },
        components: {
            InputField,
            checkIcon,
            checkWhiteIcon,
            plusIcon,
            appleIcon,
            paypalIcon,
            cardsIcon
        },
        computed: {
            isValid() {
                // card
                return this.nameValid(this.cardName) && this.cardComplete
            }
        },
        methods: {

            weekFromNow() {
                var nowDate = new Date();
                // console.log(newDate);
                nowDate.setDate(nowDate.getDate() + 7);
                
                const dateOptions = { month: 'long', day: 'numeric' };
                const dateString = nowDate.toLocaleDateString('en-US', dateOptions);

                return dateString;
            },
            nameValid(name) {
                if (name.trim().length == 0) { return false; }
                return name.length >= 2;
            },
            
            goNextStep() {

                if (!this.isValid) {
                    return;
                }

                this.$emit('showLoading');

                const stripeTokenURL = 'https://old.ohanaisfamily.com/api/stripeSubscribe';

                const cardData = {
                    name: this.cardName
                }

                stripe.createToken(card, cardData)
                .then((result) => {
                    
                    if (result.error) {
                        // Inform the customer that there was an error.
                        // var errorElement = document.getElementById('card-errors');
                        // errorElement.textContent = result.error.message;

                        console.log('error trying to create stripe token:');
                        console.log(result.error);

                        this.$emit('dismissLoading');
                        this.$emit('showError', result.error.message);

                    } else {

                        // Send the token to your server.
                        // stripeTokenHandler(result.token);
                        console.log('success!');
                        console.log(result);
                        console.log('sending to backend...');

                        const body = {
                            token: result.token,
                            email: this.$parent.currentEmail,
                            name: this.cardName,
                            firebase_uid: this.$parent.currentUid
                        }

                        axios.post(stripeTokenURL, body)
                        .then(response => {
                            console.log(response);
                            this.$emit('dismissLoading');
                            this.$emit('nextStep');

                            // Amplitude
                            amplitude.getInstance().logEvent('card_success');

                            // Facebook
                            fbq('track', 'StartTrial');

                        })
                        .catch(error => {
                            console.log(error);
                            this.$emit('dismissLoading');
                            this.$emit('showError', error.message);

                            // Amplitude
                            const data = {
                                error: error
                            }
                            amplitude.getInstance().logEvent('card_error', data);
                        })
                    }
                });
            }
        },
        mounted() {

            // Amplitude
            amplitude.getInstance().logEvent('signup_page_creditcard_loaded');

            // Facebook
            fbq('track', 'InitiateCheckout');

            window.scrollTo(0, 0);

            const {title, subtitle, form, button, service, payment} = this.$refs;
            tl
            .from([title, subtitle], 1.2, {autoAlpha: 0, ease: Power2.easeOut})
            .from([form, service, payment], 1.2, {autoAlpha: 0, ease: Power2.easeOut}, "-=.8")
            .from(button, 1.2, {scale: .9, autoAlpha: 0, ease: Power2.easeOut}, "-=.8")

            const nameInput = document.getElementById("name");
            const nameStyle = window.getComputedStyle(nameInput, null);

            window.addEventListener('resize', () => {
                const nameStyle = window.getComputedStyle(nameInput, null);
                card.update({ style: { base: { fontSize: nameStyle.fontSize }}});
            })

            // Card element
            var style = {
                base: {
                    // Add your base input styles here. For example:
                    fontSize: nameStyle.fontSize,
                    color: "#32325d",
                    fontStyle: 'Noto Sans',
                    fontWeight: '400',
                    fontSmoothing: 'antialiased',
                    '::placeholder': {
                        color: '#BCBCBC',
                    },
                }
            };

            // var card = elements.create('card', {style: style});
            card = elements.create('card', {style: style});

            // Add an instance of the card Element into the `card-element` <div>.
            card.mount('#card-element');

            card.addEventListener('change', (event) => {

                const displayError = document.getElementById('card-errors');
                this.cardComplete = event.complete;

                if (event.error) {
                    console.log('error!:', event)
                    this.cardErrorMessage = event.error.message;
                } else {
                    this.cardErrorMessage = '';
                }
            });
        },
        beforeDestroy() {
            
            // Must explicitly destroy the card or else it'll blow up with errors
            card.destroy()
        }
    }
</script>




// WEBPACK FOOTER //
// Step5_CreditCard.vue?027edbfa